import styles from './index.scss'
import { ImageViewer } from 'antd-mobile'
import { useState } from 'react'

export type IDpBusinessCommodityGoods = {
  data?: {
    img?: string // 商品图片
    title?: string | React.ReactNode // 商品名称
    tips?: string // 规格
    num?: string | number // 数量
    twoTips?: string // 地址等
    tags?: React.ReactNode // 标签区域（网点标签等）
  }
  goodsStyles?: React.CSSProperties
  imgStyles?: React.CSSProperties
  style?: React.CSSProperties
}

const GOODS = (props: IDpBusinessCommodityGoods) => {
  const [imageVisible, setImageVisible] = useState(false)
  return (
    <>
      <div className={styles["dp-business-commodity--goods"]} style={props?.style}>
        <div className={styles["dp-business-commodity--goods-card"]} style={props?.goodsStyles}>
          <div
            className={styles["dp-business-commodity--goods-card-image"]}
            style={{ ...props?.imgStyles, backgroundImage: `url(${props?.data?.img})` }}
            onClick={() => setImageVisible(true)}
          >
          </div>
          <div className={styles["dp-business-commodity--goods-card-info"]}>
            <div className={styles["dp-business-commodity--goods-card-title"]}>{props?.data?.title}</div>
            <div className={styles["dp-business-commodity--goods-card-flex"]}>
              <div className={styles["dp-business-commodity--goods-card-tips"]}>{props?.data?.tips}</div>
              {
                props?.data?.num && <div className={styles["dp-business-commodity--goods-card-num"]}>x{props?.data?.num}</div>
              }
            </div>
            <div className={styles["dp-business-commodity--goods-card-flex"]}>
              <div className={styles["dp-business-commodity--goods-card-tips"]}>{props?.data?.twoTips}</div>
            </div>
            {props?.data?.tags && (
              <div className={styles["dp-business-commodity--goods-card-tags"]}>{props.data.tags}</div>
            )}
          </div>
        </div>
      </div>
      <ImageViewer
        image={props?.data?.img}
        getContainer={document.body}
        visible={imageVisible}
        onClose={() => setImageVisible(false)}
      />
    </>
  )
}

export default GOODS
